// extracted by mini-css-extract-plugin
export default {"cell":"gKfkUj9JGT1Mnt9HM_Mg","tooltip":"WHvYEc6INUTkRGB6NGq5"};